var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4C7642F5666923D0D8301Ca0B0003A2156829Edc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12.1445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.51987 0C3.12691 0 1.17188 1.95503 1.17188 4.34799C1.17188 7.31965 5.0663 11.6833 5.22271 11.871C5.37911 12.043 5.64499 12.043 5.8014 11.871C5.97344 11.6833 9.85223 7.31965 9.85223 4.34799C9.85223 1.95503 7.89719 0 5.50423 0H5.51987ZM5.51987 6.52199C4.31557 6.52199 3.33023 5.53666 3.33023 4.33236C3.33023 3.12806 4.31557 2.14272 5.51987 2.14272C6.72417 2.14272 7.70951 3.12806 7.70951 4.33236C7.70951 5.53666 6.72417 6.52199 5.51987 6.52199Z",
    fill: "var(--fill-0, #00B14F)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4C7642F5666923D0D8301Ca0B0003A2156829Edc);
export default __webpack_public_path__ + "static/media/4c7642f5666923d0d8301ca0b0003a2156829edc.749ce9731a3d53a5a0de9296957414c4.svg";
export { ForwardRef as ReactComponent };